import { HistoryPeriod } from '../interfaces/HistoryPeriod';

export const applicableHistoryPeriods: HistoryPeriod[] = [
  HistoryPeriod.WEEK,
  HistoryPeriod.MONTH,
  HistoryPeriod.THREE_MONTHS,
  HistoryPeriod.SIX_MONTHS,
  HistoryPeriod.ALL,
];
